// read-only LoginProvider
import React, { createContext, useContext, useEffect, useState } from "react"
import JWTApi, { IUser } from "../../libs/login/JWTApi"
import _ from "lodash"

type TAuthProvider = {
    isLoggedIn:boolean,
}

interface TAuthContextProps {
    api:JWTApi
    children:JSX.Element
}

const AuthContext = createContext<TAuthProvider>({} as any)
export const useAuth = () => useContext(AuthContext)

export default function AuthProvider(props:TAuthContextProps) {
    const {api} = props
    const [isLoggedIn,setIsLoggedIn] = useState<boolean>(props.api.isLoggedIn)

    const onAuth = (user:IUser|null) => setIsLoggedIn(!!user)

    useEffect(() => {
        console.log("register on auth")
        api.onAuth(onAuth)
        return () => { api.removeListener("auth", onAuth) }
    }, [])

    return <AuthContext.Provider value={{isLoggedIn}}>
        {props.children}
    </AuthContext.Provider>
}